export default __webpack_public_path__ + "static/media/05.d723b3b1.png";